module.exports = __webpack_public_path__ + "static/media/AxiosIcon.41cc2d87.svg";